import request from '@/utils/request'

// 获取验证码
export function getCode (data) {
  return request({
    url: '/home/send_sms',
    method: 'post',
    data
  })
}

// 上传图片
export function uploadFile (data) {
  return request({
    url: '/home/upload',
    method: 'post',
    data: data,
    timeout: 1200000
  })
}

// 登陆
export function goLogin (data) {
  return request({
    url: '/home/login',
    method: 'post',
    data
  })
}

// 退出登陆
export function outLogin () {
  return request({
    url: '/home/logout',
    method: 'get'
  })
}

// 获取当前账号认证数据
export function getDetail (data) {
  return request({
    url: '/home/app/enterprise_apply_status',
    method: 'post',
    data
  })
}

// 提交认证发发息
export function submitApply (data) {
  return request({
    url: '/home/app/enterprise_apply',
    method: 'post',
    data
  })
}

// 验证营业执照并获取营业执照数据
export function checkLicense (data) {
  return request({
    url: '/home/app/license_check',
    method: 'post',
    data
  })
}

// 提交当前使用场景
export function submitUseApply (data) {
  return request({
    url: '/home/app/information_apply',
    method: 'post',
    data
  })
}

// 获取邮箱验证码
export function getEmailCode (data) {
  return request({
    url: '/home/send_email',
    method: 'post',
    data
  })
}

// 邮箱登陆
export function goLoginEmail (data) {
  return request({
    url: '/home/login_by_email',
    method: 'post',
    data
  })
}

// 注册邮箱账号
export function goRegisterEmail (data) {
  return request({
    url: '/home/register_by_email',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword (data) {
  return request({
    url: '/home/reset_password',
    method: 'post',
    data
  })
}

// 重置官网商户密码
export function resetPsw (data) {
  return request({
    url: '/home/app/reset_psw',
    method: 'post',
    data
  })
}

// 下单
export function buyPackage (data) {
  return request({
    url: '/home/app/buy_package',
    method: 'post',
    data
  })
}

 // 获取商户后台登录白名单列表
export function getAdminLoginWhitelist(data) {
  return request({
    url: '/home/app/admin_login_whitelist',
    method: 'post',
    data
  })
}

// 添加商户后台登录白名单
export function addAdminLoginWhitelist(data) {
  return request({
    url: '/home/app/add_admin_login_whitelist',
    method: 'post',
    data
  })
}

// 删除商户后台登录白名单
export function delAdminLoginWhitelist(data) {
  return request({
    url: '/home/app/del_admin_login_whitelist',
    method: 'post',
    data
  })
}

// 获取安卓最新下载地址
export function getAndDownUrl() {
  return request({
    url: '/home/latest_local_apk',
    method: 'get'
  })
}

// 补充法人身份证
export function supplementLegalIdCard(data) {
  return request({
    url: '/home/app/supplement_legal_id_card',
    method: 'post',
    data
  })
}

// 获取安卓最新版本号
export function getAndVer() {
  return request({
    url: '/home/app/version/latest',
    method: 'get'
  })
}

